import { useState } from 'react';

import {
  checkEmailEmpty,
  checkEmailFormat,
  checkPasswordEmpty,
} from '../components/EmailSectionHelpers';

export const useEmailValidation = (onErrorClear?: () => void) => {
  const [localError, setLocalError] = useState<string | null>(null);

  const validateEmail = (email: string): boolean => {
    if (onErrorClear) onErrorClear();

    if (!checkEmailEmpty(email, setLocalError)) return false;

    if (!checkEmailFormat(email, setLocalError)) return false;

    setLocalError(null);

    return true;
  };

  const validatePassword = (password: string): boolean => {
    if (onErrorClear) onErrorClear();

    if (!checkPasswordEmpty(password, setLocalError)) return false;

    setLocalError(null);

    return true;
  };

  return { localError, setLocalError, validateEmail, validatePassword };
};
